"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoherencyError = exports.ItemCardinality = exports.ItemRole = void 0;
/**
 * IN ACTIVE DEVELOPMENT
 *
 * Please note that this new workflow model is under active development, tracked by this work item:
 *
 * https://office.visualstudio.com/DefaultCollection/ISS/_workitems/edit/4849590
 *
 * It is not yet supported for general use, please contact PBaer and YutYe if you are interested in piloting.
 */
/**
 * Whether an item functions as an input item (provided to the workflow) or an output item (an annotation produced by
 * the workflow).
 */
var ItemRole;
(function (ItemRole) {
    ItemRole[ItemRole["Input"] = 1] = "Input";
    ItemRole[ItemRole["Output"] = 2] = "Output";
})(ItemRole = exports.ItemRole || (exports.ItemRole = {}));
/**
 * Cardinality of workflow model items. Positive numbers are reserved for exact counts.
 */
var ItemCardinality;
(function (ItemCardinality) {
    ItemCardinality[ItemCardinality["Single"] = 1] = "Single";
    ItemCardinality[ItemCardinality["Any"] = -1] = "Any";
    ItemCardinality[ItemCardinality["Optional"] = -2] = "Optional";
    ItemCardinality[ItemCardinality["Some"] = -3] = "Some"; // At least one
})(ItemCardinality = exports.ItemCardinality || (exports.ItemCardinality = {}));
/**
 * Exception generated by IWorkflowModelItem.loadSubtree() if the underlying data store no longer has a snapshot of
 * the requested model data that is coherent with the rest of the currently loaded model, i.e. there is a risk of
 * inconsistency between model items.
 */
var CoherencyError = /** @class */ (function (_super) {
    __extends(CoherencyError, _super);
    function CoherencyError(message) {
        if (message === void 0) { message = 'CoherencyError'; }
        var _this = _super.call(this, message) || this;
        _this.__proto__ = CoherencyError.prototype;
        return _this;
    }
    return CoherencyError;
}(Error));
exports.CoherencyError = CoherencyError;
//# sourceMappingURL=workflow-model.js.map